//------------------------------------------------------------------------
// Timeline Carousel
// https://github.com/Threespot/cct-wp/issues/58
//------------------------------------------------------------------------
import Flickity from '../lib/flickity-custom';

export default class JoyCarousel {
  constructor(el, opts) {
    this.el = el;
    let self = this;

    // Main carousel
    this.flkty = new Flickity(this.el, {
      // Note: Path is from “chev-left-flickity.svg”
      arrowShape: 'M70.97 97.91a7.05 7.05 0 0 0 0-10.01L33.02 50l37.95-37.9A7.08 7.08 0 0 0 60.95 2.06L18.06 45.01a7.05 7.05 0 0 0 0 9.97l42.9 42.93a7.05 7.05 0 0 0 10 0Z',
      // adaptiveHeight: false, // Changes height of carousel to fit height of selected slide.
      draggable: true,
      friction: 0.6,// Higher friction makes the slider feel stickier and less bouncy (default 0.28)
      // groupCells: true,
      pageDots: false,
      prevNextButtons: true,
      selectedAttraction: 0.062,// Higher attraction is faster (default 0.025)
      wrapAround: false,
      on: {
        ready: function() {
          // NOTE: “this” refers to the Flickity object
          self.onReadyCallback(this);
        }
      }
    });
  }

  onReadyCallback(flkty) {
    // Improve carousel accessibility
    this.a11ySetup(flkty);

    // Add resize class on initial load
    // (for equal heights, see Flickity.prototype.resize above)
    flkty.element.classList.add('flickity-resize');

    // Trigger resize once web fonts have loaded
    document.documentElement.addEventListener('fonts-loaded', () => {
      flkty.resize();
    });
  }

  // Issues pertaining to accessibility
  // https://github.com/mozilla-rally/site/issues/262
  // https://github.com/mozilla-rally/site/issues/278
  a11ySetup(flkty) {
    // Update “role” attribute to account for markup changes after Flickity inits
    // (Flickity doesn’t work with ul/li so we used divs with “role” attrs)
    flkty.element.removeAttribute('role');

    // Update cell markup
    flkty.cells.forEach(cell => {
      // Remove “role” attribute which is only for “no-js” accessibility
      cell.element.removeAttribute('role');
      // Add tabindex="-1" to cells so we can programmatically focus them
      cell.element.setAttribute('tabindex', '-1');
    });

    // Focus the selected cell after it has settled
    flkty.on('settle', () => {
      if (flkty.options.shouldFocus) {
        flkty.selectedElement.focus();
        flkty.options.shouldFocus = false;
      }
    });
  }
}
